<template>
    <div class="ly_gas_monitor">
        <el-form label-width="60px" :inline="true" :model="searchForm" class="leader-style-form">
            <el-form-item label="时间">
                <el-date-picker
                    v-model="searchForm.time"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :picker-options="disableDate"
                    :clearable="false"
                    :editable="false"
                    @change="getGasDayList"
                ></el-date-picker>

                <el-button class="leader-common-button" @click="lastDay" size="medium">上一日</el-button>
                <el-button
                    class="leader-common-button"
                    :disabled="
                        this.sysDate ===
                        this.searchForm.time
                    "
                    @click="nextDay"
                    size="medium"
                >下一日</el-button>
                <el-button class="leader-common-button" size="medium" @click="getGasDayList">查询</el-button>
            </el-form-item>
        </el-form>
        <div class="ly_gas_card_data">
            <div class="ly_gas_card_item">
                <div class="ly_gas_item_data">
                    <div class="ly_gas_item_data_title">0点班</div>
                    <div class="ly_gas_item_data_data">
                        {{ zero_value }}
                        <span>m³</span>
                    </div>
                </div>
                <!-- <div class="ly_gas_item_class">
                    <div class="ly_gas_item_class_item">
                        <div style="height: 30px;line-height: 30px;">0点班</div>
                        <div style="color: #56fcff;height: 30px;line-height: 20px;">
                            {{ zero_power }}
                            <span>kwh</span>
                        </div>
                    </div>
                    <div class="ly_gas_item_class_item">
                        <div style="height: 30px;line-height: 30px;">8点班</div>
                        <div style="color: #56fcff;height: 30px;line-height: 20px;">
                            {{ eight_power }}
                            <span>kwh</span>
                        </div>
                    </div>
                    <div class="ly_gas_item_class_item">
                        <div style="height: 30px;line-height: 30px;">16点班</div>
                        <div style="color: #56fcff;height: 30px;line-height: 20px;">
                            {{ sixteen_power }}
                            <span>kwh</span>
                        </div>
                    </div>
                </div>-->
            </div>
            <div class="ly_gas_card_item">
                <div class="ly_gas_item_data">
                    <div class="ly_gas_item_data_title">8点班</div>
                    <div class="ly_gas_item_data_data">
                        {{ eight_value }}
                        <span>m³</span>
                    </div>
                </div>
                <!-- <div class="ly_gas_item_other">
                    <span>当月无功电量：{{ reactive_power_month }}</span>
                    <span>{{ remonthUnit }}</span>
                </div>-->
            </div>
            <div class="ly_gas_card_item">
                <div class="ly_gas_item_data">
                    <div class="ly_gas_item_data_title">16点班</div>
                    <div class="ly_gas_item_data_data">
                        {{ sixteen_value }}
                        <span>m³</span>
                    </div>
                </div>
                <!-- <div class="ly_gas_item_other">
                    <span>当月无功电量：{{ reactive_power_year }}</span>
                    <span>{{ reyearUnit }}</span>
                </div>-->
            </div>
        </div>
        <div class="chart_wrap">
            <div class="title">
                <div class="green"></div>当日标准总量趋势
            </div>
            <div class="echart_container">
                <v-chart :auto-resize="true" :options="yearBar" ref="yearBar" />
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/dataZoom";
import * as api from "../../../../http/Use_electricity_monitor";
import moment from "moment";
export default {
    props: {
        id: {
            type: String,
        }
    },
    watch: {
        id: {
            handler(newVal) {
                this.getSysDate();
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            searchForm: {
                time: ""
            },
            sysDate: "",
            disableDate: {
                disabledDate: time => {
                    return (
                        time.getTime() >
                        new Date(
                            new Date(this.sysDate).toLocaleDateString()
                        ).getTime()
                    );
                }
            },
            zero_value: "",
            eight_value: "",
            sixteen_value: "",
            x_list: [],
            value_list: [],
        }
    },
    methods: {
        //获取系统时间
        getSysDate() {
            api.getSysDate({}).then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.time = res.bus_json.sysdate;
                    this.sysDate = res.bus_json.sysdate;
                    this.getGasDayList();
                }
            });
        },
        getGasDayList() {
            api.getGasDayList({
                date: this.searchForm.time,
                point_id: this.id
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.zero_value = res.bus_json.day_value.zero_value;
                    this.eight_value = res.bus_json.day_value.eight_value;
                    this.sixteen_value = res.bus_json.day_value.sixteen_value;
                    this.x_list = res.bus_json.hour_list;
                    this.value_list = res.bus_json.value_list;

                }
            })
        },
        //上一日
        lastDay() {
            const now = moment(this.searchForm.time);
            this.searchForm.time = now.subtract(1, "days").format("YYYY-MM-DD");
            this.getGasDayList();
        },
        // 下一日
        nextDay() {
            const now = moment(this.searchForm.time);
            this.searchForm.time = now.add(1, "days").format("YYYY-MM-DD");
            this.getGasDayList();
        },
    },
    computed: {
        yearBar() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["标准总量"],
                    textStyle: {
                        color: '#fff'
                    }
                },
                grid: {
                    left: "2%",
                    right: "2%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        data: this.x_list,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: '#fff'
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff'
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位：m³",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: '#fff'
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff'
                            }
                        }
                    }
                ],
                series: [{
                    name: "标准总量",
                    type: "bar",
                    stack: "elc",
                    data: this.value_list,
                    itemStyle: {
                        color: "#fe7f66"
                    }
                },],
            };
            return options;
        }
    }
}
</script>
<style lang="scss">
.ly_gas_monitor {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    .ly_gas_card_data {
        display: flex;
        justify-content: space-around;
        width: 100%;
        height: 110px;
        .ly_gas_card_item {
            width: 32%;
            height: 100%;
            box-sizing: border-box;
            border: 1px solid #56fcff;
            border-radius: 10px;
            .ly_gas_item_data {
                text-align: center;
                font-size: 14px;
                height: 90px;
                line-height: 90px;
                &_title {
                    color: #56fcff;
                    height: 40px;
                    line-height: 60px;
                }
                &_data {
                    color: #fe7f66;
                    height: 50px;
                    line-height: 50px;
                    font-size: 30px;
                    font-weight: bold;
                    span {
                        font-size: 14px;
                        display: inline-block;
                        margin-left: 15px;
                        color: #fff;
                    }
                }
            }
            .ly_gas_item_other {
                height: 60px;
                line-height: 40px;
                color: white;
                text-align: center;
                font-size: 14px;
            }
            .ly_gas_item_class {
                display: flex;
                justify-content: space-around;
                box-sizing: border-box;
                width: 100%;
                height: 60px;
                &_item {
                    width: 32%;
                    height: 100%;
                    box-sizing: border-box;
                    border: 1px solid #56fcff;
                    border-radius: 10px;
                    text-align: center;
                    color: white;
                    font-size: 14px;
                }
            }
        }
    }
    .chart_wrap {
        margin-top: px2Rem(20px);
        .title {
            .green {
                height: px2Rem(12px);
                width: px2Rem(5px);
                background: #56fcff;
                margin: px2Rem(10px);
                float: left;
            }
            width: 100%;
            font-size: px2Rem(16px);
            text-align: left;
            line-height: px2Rem(32px);
            height: px2Rem(32px);
            border-bottom: 0px solid #dddddd;
            color: #fff;
        }
        .echart_container {
            width: 100%;
            //   height: calc(100% - px2Rem(265px));
            position: relative;
            .changeBtn {
                position: absolute;
                top: 0;
                right: 20px;
                z-index: 9;
            }
            .echarts {
                width: 100%;
                height: px2Rem(360px);
            }
            .leader-style-table {
                width: calc(100% - 17px);
            }
        }
    }
}
</style>